import * as React from "react";

import "./Loader.scss";

export const Loader = () => <div className="Loader" />;
